'use strict';
const mmWidgets = require('../widgets/mm-widgets'),
	stripePlans = require('@mindmup/mindmup-config/src/stripe-plans');
mmWidgets.fn.invoiceViewWidget = function invoiceViewWidget(subscriptionModel) {
	return mmWidgets.each(this, function () {
		const widget = mmWidgets(this),
			invoiceTable = widget.find('[data-mm-role~="invoice"]'),
			invoiceType = widget.attr('data-mm-invoice-type'),
			invoicePayLink = widget.find('[data-mm-role~="invoice-pay-link"]'),
			invoiceItemTemplate = invoiceTable.find('[data-mm-role~="invoice-template-line"]').detach();
		subscriptionModel.addEventListener('goldAccountInfo', accountInfo => {
			const invoiceToShow = accountInfo && accountInfo.subscription && accountInfo.subscription[invoiceType];
			if (!invoiceToShow || !invoiceToShow.lines || !invoiceToShow.lines.length) {
				widget.addClass('hidden');
			} else {
				widget.removeClass('hidden');
				const invoiceItems = invoiceToShow.lines.slice(0),
					total = invoiceToShow.total || invoiceItems.reduce((currentValue, item) => currentValue + item.amount, 0),
					currency = invoiceToShow.currency || invoiceItems[0].currency,
					predictedInvoiceDate = invoiceToShow.paymentDate && new Date(invoiceToShow.paymentDate * 1000).toLocaleDateString(),
					predictedInvoiceDateText = (predictedInvoiceDate && `on ${predictedInvoiceDate}`) || 'today',
					totalItem = {description: `Total to pay ${predictedInvoiceDateText}`, amount: total, currency: currency};
				invoiceItems.push(totalItem);
				invoiceTable.empty();
				invoiceItems.forEach((item) => {
					const line = invoiceItemTemplate.clone(),
						symbol = stripePlans.currencies[item.currency].prefix,
						amount = new Number(item.amount).toFixed(2);
					line.find('[data-mm-role~="invoice-description"]').text(item.description);
					line.find('[data-mm-role~="invoice-amount"]').text(`${symbol}${amount} ${item.currency}`);
					invoiceTable.append(line);
				});
				if (invoiceToShow.url) {
					invoicePayLink.attr('href', invoiceToShow.url);
					invoicePayLink.removeClass('hidden');
				} else {
					invoicePayLink.addClass('hidden');
				}

			}
		});
	});
};
